import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminAdminsCount = z.any()
export type TagsGetAdminAdminsCount = z.infer<typeof tagsGetAdminAdminsCount>

export const querystringGetAdminAdminsCount = z.object({ "page": z.string().optional(), "perPage": z.string().optional() })
export type QuerystringGetAdminAdminsCount = z.infer<typeof querystringGetAdminAdminsCount>

export const responseGetAdminAdminsCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminAdminsCount = z.infer<typeof responseGetAdminAdminsCount>

interface IGetAdminAdminsCount extends BaseMethodType {
  tags: TagsGetAdminAdminsCount,
  querystring: QuerystringGetAdminAdminsCount,
  response: ResponseGetAdminAdminsCount
}
export const URL = '/admin/admins/count'
export const validation = {
  get: {
    tags: tagsGetAdminAdminsCount,
    querystring: querystringGetAdminAdminsCount,
    response: responseGetAdminAdminsCount
  }
}
export interface AdminAdminsCount extends BaseRouteType {
  get: IGetAdminAdminsCount
}